<template>
  <form novalidate class="md-layout" @submit.prevent="validateUser">
    <div class="md-layout-item md-elevation-0">

      <md-card class="md-elevation-0 m-5">
        <md-card-header class="md-layout md-alignment-center-left justify header-bg">
          Declaración Jurada de Origen de Fondos
        </md-card-header>
        <md-card-content class="md-layout">
          <p align="justify">
          Ante cualquier duda, comuníquese con su promotor.
          </p>
        </md-card-content> 
      </md-card>   

      <md-card class="md-elevation-0 m-5" :class="getValidationClass2('origenfondos')">
        <md-card-header class="md-layout md-alignment-center-left justify">
          Declaración jurada de origen de fondos *
        </md-card-header>
        <md-card-content class="md-layout">

          <div class="md-layout-item md-layout">
            <div class="md-layout-item md-xlarge-size-15 md-large-size-15 md-medium-size-15 md-small-size-25 md-xsmall-size-30">
              <md-checkbox v-model="form.origenfondos" value="Remuneraciones">Remuneraciones</md-checkbox>
              <md-checkbox v-model="form.origenfondos" value="Ahorros">Ahorros</md-checkbox>
              <md-checkbox v-model="form.origenfondos" value="Préstamos">Préstamos</md-checkbox>
              <md-checkbox v-model="form.origenfondos" value="Acciones">Acciones</md-checkbox>
              <md-checkbox v-model="form.origenfondos" value="Inmuebles">Inmuebles</md-checkbox>
              <md-checkbox v-model="form.origenfondos" value="Otros" @change="ChangeOption">Otros</md-checkbox>
            </div>
            <div class="md-layout md-layout-item md-gutter md-alignment-bottom-left">
                <div class="md-layout-item">

                  <md-field class="md-field-aux" :class="getValidationClass('origenfondosdes')">
                    <md-input type="text" name="otros" placeholder="Su respuesta" v-model="form.origenfondosdes" :disabled="otros" autocomplete="off" />
                    <span class="md-error" v-if="!$v.form.origenfondosdes.required">Su respuesta es obligatoria.</span>
                    <span class="md-error" v-else-if="!$v.form.origenfondosdes.alpha1">Formato inválido</span>
                    <span class="md-error" v-else-if="!$v.form.origenfondosdes.minLength">Formato inválido</span>
                  </md-field>   

                </div>

            </div>
          </div>   
          
            <div class="radioform" :class="getValidationClass('origenfondos')">
              <span class="md-error" v-if="!$v.form.origenfondos.required">Esta respuesta es obligatoria.</span>
            </div>                     

        </md-card-content> 
      </md-card>    

      <md-card class="md-elevation-0 m-5" :class="getValidationClass('detalleorigen')">
        <md-card-header class="md-layout md-alignment-center-left justify">
          Brindar detalle de la opción elegida en la pregunta anterior
        </md-card-header>
        <md-card-content>
          <p align="justify">
            En caso la información brindada en esta pregunta no sea completada o sea incongruente, se congelará el proceso de suscripción hasta comprobar el origen de los fondos.
          </p>
          
          <div>
            
            <md-field :class="getValidationClass('detalleorigen')">
              <md-input type="text" name="detalle" placeholder="Su respuesta" v-model="form.detalleorigen" autocomplete="off"/>
              <span class="md-error" v-if="!$v.form.detalleorigen.required">Esta respuesta es obligatoria.</span>
              <span class="md-error" v-else-if="!$v.form.detalleorigen.minLength">Formato inválido</span>
              <span class="md-error" v-else-if="!$v.form.detalleorigen.alpha1">Formato inválido</span>
            </md-field>            

          </div>
        </md-card-content> 
      </md-card>          

      <Botonera :form="form" :back="back" :Bottontitle="'Siguiente'"/>                  


    </div>
  </form>
</template>

<style>

</style>

<script>
import { validationMixin } from 'vuelidate'
import { alpha1 } from '../variables'
import {
  required,
  minLength,
  requiredIf,
} from 'vuelidate/lib/validators'


export default {
  mixins: [validationMixin],
  name: 'Item19',
  data: () => ({
    form:{
      origenfondos: null,
      origenfondosdes : null,
      detalleorigen: null
    }
  }),
  mounted: function(){
    this.form = this.$store.state.item.item19
  },  
  validations: {
    form: {
      origenfondos: {
        required,
      },
      origenfondosdes: {
        required: requiredIf(function(form){
          return this.findArray(form.origenfondos)
        }),
        alpha1,
        minLength: minLength(3),    
      },
      detalleorigen: {
        required,
        minLength: minLength(3),
        alpha1
      }
    },
  },
  methods: {
    back () {
      this.$emit('setBack', {id: this.$options.name})
      this.form = this.$store.state.item.item19
    },       
    ChangeOption(item){
      var that = this;
      item.find(x => {
        if(x != "Otros"){
          that.form.origenfondosdes = null
        }
      });
    },  
    validateUser () {
      this.$v.$touch()

      if (!this.$v.$invalid) {

        this.$emit('setSaveForm', {id:"19", form: this.form, index: "20"});

      }

    },
    getValidationClass (fieldName) {
      const field = this.$v.form[fieldName]

      if (field) {
        return {
          'md-invalid': field.$invalid && field.$dirty
        }
      }

    },    
    getValidationClass2 (fieldName) {
      const field = this.$v.form[fieldName]
      const field1 = this.$v.form[fieldName+"des"]

      if (field) {

        var x = field.$invalid && field.$dirty;
        var y = field1.$invalid && field1.$dirty;

        return {
          'md-invalid': x || y
        }
      }
    },
    findArray(arr){

      try {
        return (arr.find(x => x == "Otros") == "Otros")
      } catch (error) {
        return true;
      }

    }        
  },
  computed: {
    // a computed getter
    otros: function () {
      return !this.findArray(this.form.fuente)
    }
  },
  components:{
    "Botonera": () => import('./Botonera.vue')
  }
}
</script>
